import React from "react";
import { func, object as obj } from "prop-types";
import Copy from "components/shared/Copy";
import OnboardingInput from "components/onboarding/components/OnboardingInput";
import OnboardingSelect from "components/onboarding/components/OnboardingSelect";

const CarePage = ({
  formData,
  handleChange,
  invalidMessages,
  fieldValidation,
  taxonomies
}) => (
  <>
    <Copy color="darkBlue" margin="0 0 2rem" size={1} weight="600">
      Step 1: Your details
    </Copy>
    <OnboardingInput
      error={invalidMessages.lastname || invalidMessages.name}
      name="name"
      placeholder="Your full name"
      onBlur={fieldValidation}
      onChange={handleChange}
      type="text"
      value={formData.name}
      width="270px"
    />
    <OnboardingSelect
      error={invalidMessages.requested_care_type}
      name="requested_care_type"
      placeholder="Care type"
      onChange={handleChange}
      options={taxonomies.requested_care_type}
      value={formData.requested_care_type}
      width="270px"
    />
    <OnboardingSelect
      error={invalidMessages.relationship}
      name="relationship"
      placeholder="Care recipient"
      onChange={handleChange}
      options={taxonomies.care_for}
      value={formData.relationship}
      width="270px"
    />
  </>
);

CarePage.propTypes = {
  fieldValidation: func.isRequired,
  formData: obj.isRequired,
  handleChange: func.isRequired,
  invalidMessages: obj.isRequired,
  taxonomies: obj.isRequired
};

export default CarePage;
